<template>
  <div class="centerx">
    <vs-button @click="popupActivo=true" class="btn btn--green">
      <i class="fal fa-file-alt"></i>
      Documenti
    </vs-button>
    <vs-popup class="holamundo" :active.sync="popupActivo">
      <!-- Questo è il codice da inserire nella vista della route -->
      <section class="section--title-page has-no-margin">
        <h3>Le tue cartelle <span>Seleziona la cartella da visualizzare</span></h3>
        <section>
          <a href="" class="btn">
            <i class="fal fa-plus"></i>
            Aggiungi file
          </a>
          <a href="" class="btn btn--green">
            <i class="fal fa-folder"></i>
            Nuova cartella
          </a>
        </section>
      </section>
      <tabs>
        <tab name="Cartella 01">
          <div class="documents--content">
            <div class="single--document">
              <div class="single--document-title">
                Titolo file
              </div>
              <div class="single--document-actions">
                <a href="">
                  <i class="fal fa-external-link"></i>
                </a>
                <a href="">
                  <i class="fal fa-pencil-alt"></i>
                </a>
                <a href="">
                  <i class="fal fa-trash-alt"></i>
                </a>
              </div>
            </div>
            <div class="single--document">
              <div class="single--document-title">
                Titolo file 01
              </div>
              <div class="single--document-actions">
                <a href="">
                  <i class="fal fa-external-link"></i>
                </a>
                <a href="">
                  <i class="fal fa-pencil-alt"></i>
                </a>
                <a href="">
                  <i class="fal fa-trash-alt"></i>
                </a>
              </div>
            </div>
            <div class="single--document">
              <div class="single--document-title">
                Titolo file 02
              </div>
              <div class="single--document-actions">
                <a href="">
                  <i class="fal fa-external-link"></i>
                </a>
                <a href="">
                  <i class="fal fa-pencil-alt"></i>
                </a>
                <a href="">
                  <i class="fal fa-trash-alt"></i>
                </a>
              </div>
            </div>
            <div class="single--document">
              <div class="single--document-title">
                Titolo file 03
              </div>
              <div class="single--document-actions">
                <a href="">
                  <i class="fal fa-external-link"></i>
                </a>
                <a href="">
                  <i class="fal fa-pencil-alt"></i>
                </a>
                <a href="">
                  <i class="fal fa-trash-alt"></i>
                </a>
              </div>
            </div>
          </div>
        </tab>
        <tab name="Cartella 02">
        </tab>
      </tabs>
      <!-- Qua finisce il codice da inserire nella vista della route -->
    </vs-popup>
  </div>
</template>

<script>
  export default {
    data(){
      return {
        popupActivo:false,
      }
    }
  }
</script>
